import type { ProductData } from '../../../../../core/typings'

export const getProductSku = (
  products: Record<string, ProductData> | never[],
  skuId: string | null
) => {
  const sku = Object.values(products).map((product) =>
    product.data.skus.filter((productSku) => productSku.id === skuId)
  )

  return sku[0]
}
